import _ from 'lodash';

import GameData from 'shared/gameData';

export function getTalent(classId, specName, row, col) {
  const talentCell = _.get(GameData.Talents[String(classId)], `talents[${row}][${col - 1}]`);
  let talent = _.find(talentCell, { spec: { name: specName } });
  if (!talent) {
    talent = _.find(talentCell, cell => cell.spec === undefined);
  }
  return talent;
}

export function getTalentGridForSpec(classId, specName) {
  const talentGrid = [];
  if (!GameData.Talents || !GameData.Talents[classId] || !GameData.Talents[classId].talents) {
    return [];
  }
  const classTalents = GameData.Talents[classId].talents;

  let missingTalent = false;

  _.each(classTalents, tier => {
    const row = [];
    _.each(tier, column => {
      let talent = _.find(column, { spec: { name: specName } });
      if (!talent) {
        talent = _.find(column, col => col.spec === undefined);
      }
      if (talent && talent.spell) {
        row.push(talent.spell);
      } else {
        missingTalent = true;
      }
    });
    if (row) {
      talentGrid.push(row);
    }
  });
  if (missingTalent) {
    return [];
  }
  return talentGrid;
}

export function talentsArmoryToSimc(talents) {
  if (talents) {
    let newStr = '';
    for (let i = 0; i < 7; i += 1) {
      if (talents[i]) {
        newStr += talents[i] !== '.' ? String(parseInt(talents[i], 10) + 1) : '0';
      } else {
        newStr += '0';
      }
    }
    return newStr;
  }
  return '';
}

export function talentsSimcToArmory(talents) {
  if (talents) {
    let newStr = '';
    for (let i = 0; i < 7; i += 1) {
      newStr += talents[i] !== '0' ? String(parseInt(talents[i], 10) - 1) : '.';
    }
    return newStr;
  }
  return '';
}

export function findTalentBySpelld(classId, specName, spellId) {
  const classTalents = GameData.Talents[classId].talents;

  let result;

  // find spec specific talent
  for (let i = 0; i < classTalents.length; i += 1) {
    const tier = classTalents[i];
    for (let j = 0; j < tier.length; j += 1) {
      const row = tier[j];
      for (let k = 0; k < row.length; k += 1) {
        const talent = row[k];
        if (talent.spell.id === spellId && talent.spec && talent.spec.name === specName) {
          result = {
            tier: talent.tier,
            column: talent.column,
          };
        }
      }
    }
  }

  // find generic talent
  if (!result) {
    for (let i = 0; i < classTalents.length; i += 1) {
      const tier = classTalents[i];
      for (let j = 0; j < tier.length; j += 1) {
        const row = tier[j];
        for (let k = 0; k < row.length; k += 1) {
          const talent = row[k];
          if (talent.spell.id === spellId && !talent.spec) {
            result = {
              tier: talent.tier,
              column: talent.column,
            };
          }
        }
      }
    }
  }

  return result || null;
}

export default {
  getTalentGridForSpec,

  talentsArmoryToSimc,
  talentsSimcToArmory,

  rawData: GameData.Talents,
};
